// CONCEPT: promotional inserts must not hold catalog parsing on a CDN or fetch hidden slides.
const carousels = new WeakMap();

export function initBannerCarousels() {
    const nodes = document.querySelectorAll('[data-banner-carousel]');
    const activate = (node, visible) => {
        let state = carousels.get(node);
        if (!state) {
            state = { visible, loading: null, instance: null };
            carousels.set(node, state);
        }
        state.visible = visible;
        if (state.instance) {
            if (visible) state.instance.play();
            else state.instance.pause();
            return;
        }
        if (!visible || state.loading || node.querySelectorAll('[data-banner-slide]').length < 2) return;
        state.loading = import('./banner-carousel-impl.js')
            .then(({ mountBannerCarousel }) => {
                state.instance = mountBannerCarousel(node);
                if (!state.visible) state.instance.pause();
            })
            .catch((error) => {
                state.loading = null;
                node.removeAttribute('data-banner-ready');
                console.error('[banner] Could not initialize carousel', error);
            });
    };
    if (typeof IntersectionObserver === 'undefined') {
        nodes.forEach((node) => activate(node, true));
        return;
    }
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => activate(entry.target, entry.isIntersecting));
        },
        { rootMargin: '200px' }
    );
    nodes.forEach((node) => {
        if (!carousels.has(node)) {
            carousels.set(node, { visible: false, loading: null, instance: null });
            observer.observe(node);
        }
    });
}
